import { render, staticRenderFns } from "./DataEditor.vue?vue&type=template&id=0565370f&scoped=true&"
import script from "./DataEditor.vue?vue&type=script&lang=js&"
export * from "./DataEditor.vue?vue&type=script&lang=js&"
import style0 from "./DataEditor.vue?vue&type=style&index=0&id=0565370f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0565370f",
  null
  
)

export default component.exports